<template>
  <section class="custom-wrapper">
    <!-- Listing Actions -->
    <div class="table-responsive">
      <div class="row custom-row">
        <div class="col-md-2">
          <button class="btn btn-primary btn-small mb-2" @click="addMatrixInfoLookup">Add</button>
        </div>
        <div class="col-md-10">
          <div class="row">
            <div class="col-md-4">
              <z-select v-model="filter" label="Make" :options="vehicles" :inline="true" @change="refreshList" />
            </div>
            <div class="col-md-2">
              <div class="custom-show-checkbox">
                <input v-model="showInactive" type="checkbox" class="custom-checkbox" @change="refreshList" />
                <span class="ms-2">Show Inactive?</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Listing -->
      <div v-show="loading?.adasmatrixinfolookups" class="listingWrapper">
        <div class="custom-spinner"><i class="fas fa-spinner fa-spin"></i></div>
      </div>
      <div v-show="!loading?.adasmatrixinfolookups" class="listingWrapper">
        <z-table v-model="adasmatrixinfolookups" class="table table-bordered table-striped"
          :is-single-row-detail="false" sort-on="sort" sort-dir="asc" :columns="tableColumnsName"
          :is-header-fixed="true" @sort="setOrder">
          <template #tbody="props">
            <td class="custom-column-60">
              <a href="#" @click="editMatrixInfoLookup(props.row)">edit</a>
            </td>
            <td>{{ props.row.vehicleMake }}</td>
            <td class="custom-column-80 text-center">{{ props.row.yearStart }}</td>
            <td class="custom-column-80 text-center">{{ props.row.yearEnd }}</td>
            <td>{{ props.row.source }}</td>
            <td>{{ props.row.sort }}</td>
            <td class="custom-column-60-center">
              {{ props.row.isInactive ? 'Y' : '' }}
            </td>
          </template>
          <template #empty> Nothing found! </template>
        </z-table>
      </div>
    </div>
    <!-- Dialogs -->
    <dialog-matrix-info-lookup v-model="actionMatrix" @closing="closeModal" @saved="savedMatrixInfoLookup" />
    <confirm-delete v-model="actionDelete" :confirm-title="confirmTitle" :confirm-action="confirmAction"
      :confirm-question="confirmQuestion" @closing="closeModal" @proceed="performDelete" />
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZTable from '@/components/utilities/elements/Table.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ConfirmDelete from '@/components/utilities/elements/ConfirmDialog.vue'
import DialogMatrixInfoLookup from './dialog-matrix-info-lookup.vue'
export default {
  name: 'MatrixBasicInfoLookups',
  components: {
    ZTable,
    ZSelect,
    ConfirmDelete,
    DialogMatrixInfoLookup
  },
  props: {
    vehicleMake: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      actionMatrix: null,
      actionDelete: null,
      confirmTitle: 'Delete this Matrix Vehicle Make Lookup?',
      confirmAction: 'Delete',
      confirmQuestion: 'Are you sure you wish to Delete this Matrix Vehicle Make Lookup?',
      showInactive: false,
      filter: '-9999',
      orderBy: 'sort',
      sortBy: 'asc'
    }
  },
  async mounted() {
    this.filter = '-9999'
    this.orderBy = 'sort'
    this.sortBy = 'asc'
    this.showInactive = false
    if (this.vehicleMake) {
      this.filter = this.vehicleMake
    }
    await this.getList()
  },
  computed: {
    ...mapState(adasmatrixStore, ['loading', 'lookups', 'adasmatrix', 'adasmatrixinfolookups']),
    tableColumnsName() {
      return [
        {
          field: 'adasChecklistMatrixInfoLookup',
          label: '',
          sortable: false,
          class: 'custom-column-60'
        },
        {
          field: 'vehicleMake',
          label: 'Make',
          sortable: true
        },
        {
          field: 'yearStart',
          label: 'Yr Start',
          sortable: false,
          class: 'custom-column-80 text-center'
        },
        {
          field: 'yearEnd',
          label: 'Yr End',
          sortable: false,
          class: 'custom-column-80 text-center'
        },
        {
          field: 'source',
          label: 'Type',
          sortable: true
        },
        {
          field: 'sort',
          label: 'Sort',
          sortable: true
        },
        {
          field: 'isInactive',
          label: 'Inactive?',
          sortable: false,
          class: 'custom-column-60-center'
        }
      ]
    },
    vehicles() {
      let _data = []
      _data.push({
        id: -9999,
        name: 'all',
        value: -9999
      })
      if (this.lookups['VehicleMake']) {
        this.lookups['VehicleMake'].forEach((element) => {
          _data.push(element)
        })
      }
      return _data
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, [
      'getAdasMatrixInfoLookups',
      'getAdasMatrixInfoLookup',
      'initAdasMatrixInfoLookup',
      'updateAdasMatrixInfoLookup',
      'deleteAdasMatrixInfoLookup'
    ]),
    closeModal() {
      this.actionMatrix = null
      this.actionDelete = null
    },
    refreshList() {
      this.getList()
    },
    setOrder(column, sortBy) {
      this.orderBy = column.field
      this.sortBy = sortBy
      this.getList()
    },
    async getList() {
      if (this.adasmatrix.adasChecklistMatrix !== null) {
        let options = {
          id: this.adasmatrix.adasChecklistMatrix,
          orderBy: this.orderBy,
          sortBy: this.sortBy,
          type: 1,
          filter: this.filter === '-9999' ? null : this.filter,
          status: this.showInactive ? 'Inactive' : ''
        }
        console.log('Refreshing ADAS Matrix Info Lookup', options)
        await this.getAdasMatrixInfoLookups(options)
      }
    },
    addMatrixInfoLookup() {
      this.initAdasMatrixInfoLookup()
      this.updateAdasMatrixInfoLookup({
        name: 'adasChecklistMatrix',
        value: this.adasmatrix.adasChecklistMatrix
      })
      this.updateAdasMatrixInfoLookup({
        name: 'lookupType',
        value: 1
      })
      this.actionMatrix = {
        type: 'ADD',
        subtitle: this.adasmatrix.matrixItem
      }
    },
    async editMatrixInfoLookup(matrix) {
      console.log('Editing Matrix Info Lookup', matrix)
      this.getAdasMatrixInfoLookup(matrix.adasChecklistMatrixInfoLookup)
      this.actionMatrix = {
        type: 'EDIT',
        subtitle: this.adasmatrix.matrixItem
      }
    },
    async savedMatrixInfoLookup() {
      await this.getList()
      this.closeModal()
    },
    confirmDelete(matrix) {
      this.actionDelete = matrix
    },
    async performDelete(matrix) {
      this.actionDelete = null
      console.log('Deleting Matrix Info Lookup', matrix)
      await this.deleteAdasMatrixInfoLookup(matrix.adasChecklistMatrixInfoLookup)
      await this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  width: 100%;
}

.custom-row {
  margin: 0 !important;
}

.custom-spinner {
  width: 100%;
  text-align: center;
  font-size: 1.1em;
}

.listingWrapper {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 350px;
  width: 100%;
}

.custom-show-checkbox {
  position: relative;
  top: 5px;
}
</style>
